import React from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import SmartLink from '../../../SmartLink'
import Perk from './Perk'
import { $textInteractive, $textTertiary } from '../../../../styles/colors/semantics'

function Perks({ shippingInfo, taxIncluded }) {
  if (!shippingInfo) {
    return null
  }

  return (
    <div className={styles.perksSectionWrapper}>
      <Perk title={'3-year warranty'} textContent={renderWarrantyContent()}/>
      <Perk title={'Money-back guarantee'} textContent={renderMoneyBackContent()}/>
      <Perk title={'Shipping: ' + shippingInfo.transitTimeDays + ' days'} textContent={renderShippingContent()}/>
      <Perk title={'Industry leading support'} textContent={renderSupportContent()}/>
      {taxIncluded && <Perk title={ 'Prices include ' + taxIncluded} textContent={renderPricesIncludeTaxContent(taxIncluded)}/>}
      <Perk title={'Secure payment'} textContent={renderPaymentContent()}/>
    </div>
  )
}

export const renderPricesIncludeTaxContent = (taxIncluded) => {
  return (
    <>
      <Text type="heading-3">All prices shown include {taxIncluded}.</Text>
      <Spacer size={32}/>
      <Text type="medium">Final price at checkout includes applicable taxes. No additional VAT will be charged.</Text>
      <Spacer size={32}/>
      { renderContactSupportCta() }
    </>
  )
}

export const renderWarrantyContent = () => {
  return (
    <>
      <Text type="heading-3">Hardware warranty</Text>
      <Spacer size={32}/>
      <Text type="heading-5">{'What is covered?'}</Text>
      <Spacer size={16}/>
      <Text type="medium">Your VRS® Racing hardware is covered for 3 years from your purchase date.</Text>
      <Spacer size={16}/>
      <Text type="medium">This warranty ensures your product is free from defects in materials and workmanship under normal use.</Text>
      <Spacer size={16}/>
      <Text type="medium">Covered products include all VRS® Racing hardware.</Text>
      <Spacer size={32}/>
      <Text type="heading-5">{"What's not covered?"}</Text>
      <Spacer size={16}/>
      <Text type="medium">This warranty does not cover damage from accidents, misuse, unauthorized modifications, or use with non-VRS® parts. It also excludes normal wear and tear, cosmetic damage, and issues from not following product instructions.</Text>
      <Spacer size={32}/>
      <Text type="medium">For more details visit our full <SmartLink href={'/warranty-policy'}>warranty policy.</SmartLink></Text>
      <Spacer size={32}/>
      { renderContactSupportCta() }
    </>
  )
}

export const renderMoneyBackContent = () => {
  return (
    <>
      <Text type="heading-3">Money-Back Guarantee</Text>
      <Spacer size={32}/>
      <Text type="medium">If you’re not completely satisfied with your VRS purchase, you can request a full refund within 30 days—no questions asked. Just make sure the product is undamaged and returned in its original packaging with all accessories.</Text>
      <Spacer size={16}/>
      <Text type="medium">After 30 days, returns may be accepted at our discretion and may be subject to a restocking fee. Return shipping costs apply.</Text>
      <Spacer size={32}/>
      { renderContactSupportCta() }
    </>
  )
}

export const renderShippingContent = () => {
  return (
    <>
      <Text type="heading-3">Shipping information</Text>
      <Spacer size={32}/>
      <Text type="medium">We usually process your order within 1-2 business days when your order is in stock. Shipping often takes another 4-5 business days, sometimes eight or more for certain locations, unless a different timeframe is stated in the product listing.</Text>
      <Spacer size={16}/>
      <Text type="medium">For a more detailed breakdown and more shipping information, visit our <SmartLink href={'/shipping-information'}>shipping information document.</SmartLink></Text>
      <Spacer size={32}/>
      { renderContactSupportCta() }
    </>
  )
}

export const renderSupportContent = () => {
  return (
    <>
      <Text type="heading-3">Customer support</Text>
      <Spacer size={32}/>
      <Text type="medium">Our focus is on our customers—staying connected with our community and offering the technical support they can count on.</Text>
      <Spacer size={32}/>
      { renderContactSupportCta() }
    </>
  )
}

export const renderPaymentContent = () => {
  return (
    <>
      <Text type="heading-3">Payment</Text>
      <Spacer size={32}/>
      <Text type="medium">Accepted payments methods vary based on your country and region, and will be listed when you make a purchase. We typically accept credit/debit/virtual card payments (for example: VISA, MasterCard, American Express, Discover, JCB, Diners Club, 3DS, etc.) through the established payment processor Stripe. In some countries and regions we additionally offer some EU-specific payment options (like Klarna, iDeal and others).</Text>
      <Spacer size={16}/>
      <Text type="medium">For more details visit our <SmartLink href={'/payment-and-security-information'}>payment and security information document.</SmartLink></Text>
      <Spacer size={32}/>
      { renderContactSupportCta() }
    </>
  )
}

export const renderContactSupportCta = () => {
  return (
    <>
      <div className={styles.contactSupport} onClick={() => window.open('/contact', '_self')}>
        <Text type="heading-6" color={$textTertiary.light}>Need more help?</Text>
        <Text type="medium" color={$textInteractive.light}>Contact support</Text>
      </div>
    </>
  )
}

export default Perks
